// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2enyP","large":"styles_large__381vK"};